// extracted by mini-css-extract-plugin
export default {"heading":"NF-z","signin":"OF-z","signupBtn":"PF-z","disabled":"QF-z"};